import type React from 'react';

import {
  ButtonGroup,
  FormField,
  FormHelp,
  IconBuildingOutline,
  IconHouseOutline,
  Label,
  ToggleButton,
} from '@zillow/constellation';

import type { Section } from '../../../models/index';
import { PROPERTY_TYPE } from '../../../constants/index';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  children?: React.ReactNode;
};

function PropertyType_v1({ section, setSectionValues, children }: Props): JSX.Element {
  function onSingleFamily(_e: React.SyntheticEvent<HTMLButtonElement>): void {
    setSectionValues({
      [PROPERTY_TYPE.FIELD_NAME.TYPE_SINGLE_FAMILY]: true,
      [PROPERTY_TYPE.FIELD_NAME.TYPE_MULTI_FAMILY]: false,
    });
  }

  function onMultiFamily(_e: React.SyntheticEvent<HTMLButtonElement>): void {
    setSectionValues({
      [PROPERTY_TYPE.FIELD_NAME.TYPE_SINGLE_FAMILY]: false,
      [PROPERTY_TYPE.FIELD_NAME.TYPE_MULTI_FAMILY]: true,
    });
  }

  return (
    <>
      <FormField
        marginBottom={children ? 'sm' : 0}
        label={<Label size="lg">What type of property is it?</Label>}
        control={
          <ButtonGroup conjoined aria-label="property type" fluid>
            <ToggleButton
              pressed={section.getFieldValue(PROPERTY_TYPE.FIELD_NAME.TYPE_SINGLE_FAMILY)}
              icon={<IconHouseOutline />}
              onClick={onSingleFamily}
              dataTest="property-type-v1-single-family-home-btn"
            >
              Single-family home
            </ToggleButton>
            <ToggleButton
              pressed={section.getFieldValue(PROPERTY_TYPE.FIELD_NAME.TYPE_MULTI_FAMILY)}
              icon={<IconBuildingOutline />}
              onClick={onMultiFamily}
              dataTest="property-type-v1-multi-family-home-btn"
            >
              Multi-family home
            </ToggleButton>
          </ButtonGroup>
        }
        description={
          <FormHelp>
            Apartments, condos, duplex/multiplexes, basement apartments, and in-law units are considered multi-family
            homes
          </FormHelp>
        }
      />
      {children}
    </>
  );
}

export default PropertyType_v1;
